import { Box, Image, Text } from '@chakra-ui/react';
import WalmartLogo from '../assets/images/WM-Realm Logo-Latest.png';
// import SiteBlockedBG from '../assets/images/LockedBG.jpg';
// import SiteBlockedBGMobile from '../assets/images/LockedBGMobile.jpg';
import React from 'react';
// import useWindowDimensions from '../utils/useWindowDimensions';

interface SiteBlockedProps {
  active: boolean;
}

function SiteBlocked({ active }: SiteBlockedProps) {
  // const { width } = useWindowDimensions();

  return (
    <Box
      opacity={active ? 1 : 0}
      visibility={active ? 'visible' : 'hidden'}
      transition="all 0.2s ease-in-out"
      width="100%"
      height="100vh"
      position="fixed"
      userSelect="none"
      background="radial-gradient(68.41% 65.21% at 75.57% 38.7%, #4EAAFF 0%, #013ABD 100%)"
    >
      {/* <Image
        src={width < 769 ? SiteBlockedBGMobile : SiteBlockedBG}
        position="absolute"
        top={0}
        bottom={0}
        objectFit="cover"
        height="100%"
        width="100%"
      /> */}
      <Box
        position="absolute"
        gap="20px"
        padding="20px"
        height="100%"
        width="100%"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Image
          src={WalmartLogo}
          objectFit="contain"
          alt="walmart logo"
          loading="lazy"
          width={['220px', '220px', '220px', '220px', '220px']}
          mb={['32px']}
        />
        <Text
          fontSize={['20px', '20px', '32px', '32px', '32px']}
          color="white"
          fontFamily="EverydaySans-Bold-Web"
          textAlign="center"
        >
          New shops coming soon.
        </Text>
      </Box>
    </Box>
  );
}

export default SiteBlocked;
